jQuery( function( $ ) {
    "use strict"

    vector.smoothScrollAll();
    vector.menuDropdown( '#main__nav', '#desktop__menu--screen' );
    vector.mobileMenu( '#mobile__menu', '#mobile__menu--button', '#mobile__menu--screen' );

    $( '[data-account-prompt]' ).each( function() {
        var $prompt = $( this );

        window.setTimeout( function() {
            $prompt.addClass( 'is-dismissed' ).attr( 'aria-hidden', 'true' );
        }, 4000 );
    } );

} );

jQuery( function( $ ) {
    'use strict';

    var $drawers = $( '[data-archive-filter-drawer]' );
    var mobile_query = '(max-width: 1079.98px)';

    if ( ! $drawers.length ) {
        return;
    }

    function isMobileLayout() {
        return window.matchMedia && window.matchMedia( mobile_query ).matches;
    }

    function updateBodyLock() {
        $( 'body' ).toggleClass( 'archive-filter-drawer-open', $drawers.filter( '.is-open' ).length > 0 );
    }

    function setDrawer( $drawer, is_open ) {
        var drawer_id = $drawer.attr( 'id' );
        var $toggle    = $( '[data-archive-filter-toggle][aria-controls="' + drawer_id + '"]' );

        $drawer.toggleClass( 'is-open', is_open ).attr( 'aria-hidden', is_open ? 'false' : 'true' );
        $toggle.attr( 'aria-expanded', is_open ? 'true' : 'false' );
        updateBodyLock();

        if ( is_open ) {
            var $focus_target = $drawer.find( '.archive-filter-drawer__sidebar input' ).first();

            if ( ! $focus_target.length ) {
                $focus_target = $drawer.find( '[data-archive-filter-close]' ).last();
            }

            $focus_target.trigger( 'focus' );
        }
    }

    $drawers.each( function() {
        var $drawer = $( this );
        var drawer_id = $drawer.attr( 'id' );
        var $toggle = $( '[data-archive-filter-toggle][aria-controls="' + drawer_id + '"]' );

        if ( isMobileLayout() ) {
            setDrawer( $drawer, false );
        } else {
            $drawer.attr( 'aria-hidden', 'false' );
        }

        $toggle.on( 'click.archiveFilterDrawer', function() {
            setDrawer( $drawer, true );
        } );

        $drawer.on( 'click.archiveFilterDrawer', '[data-archive-filter-close]', function() {
            setDrawer( $drawer, false );
        } );
    } );

    $( document ).on( 'keydown.archiveFilterDrawer', function( event ) {
        if ( 'Escape' !== event.key ) {
            return;
        }

        $drawers.filter( '.is-open' ).each( function() {
            setDrawer( $( this ), false );
        } );
    } );

    $( window ).on( 'resize.archiveFilterDrawer', function() {
        if ( isMobileLayout() ) {
            return;
        }

        $drawers.each( function() {
            var $drawer = $( this );

            setDrawer( $drawer, false );
            $drawer.attr( 'aria-hidden', 'false' );
        } );
    } );

	
} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/app.js